import api from './api';

const reporteService = {
  generar: async (tipo, periodo_inicio, periodo_fin, formato) => {
    const { data } = await api.post('/reportes', {
      tipo, periodo_inicio, periodo_fin, formato,
    });
    return data.data;
  },

  listar: async () => {
    const { data } = await api.get('/reportes');
    return data.data;
  },
};

export default reporteService;